import { selectSuperAgentLevelInfo } from './selectAgentLevelInfo';
import { IState } from '../../store';

export const selectIsHighResponsibility = (state: IState): boolean => {
  const superAgentLevelInfo = selectSuperAgentLevelInfo(state);

  return Boolean(superAgentLevelInfo?.showHighResponsibility);
};
